export const subcateorydata = [
	{
		"id":1,
		"img": "assets/img/products/Amande.JPG",
		"model": "AMANDE",
		"description": "",
		"status": "Active",
		
	},
	{
		"id":2,
		"img": "assets/img/products/Evenementiel.JPG",
		"model": "ÉVÈNEMENTIEL",
		"description": "",
		"status": "Active",
		
	},
	{
		"id":3,
		"img": "assets/img/products/SaleViande.JPG",
		"model": "SALÉ VIANDE",
		
		"description": "",
		"status": "Active",
		
	},
	{
		"id":7,
		"img": "assets/img/products/Mignardise.JPG",
		"model": "MIGNARDISE ET MACARON",
		
		"description": "",
		"status": "Active",
		
	},
	{
		"id":4,
		"img": "assets/img/products/product4.jpg",
		"model": "JUS DE FRUITS",
		
		"description": "",
		"status": "Active",
		
	},
	{
		"id":5,
		"img": "assets/img/products/product5.jpg",
		"model": "GLACES",
		"description": "",
		"status": "Active",
		
	},
	{
		"id":6,
		"img": "assets/img/products/product6.jpg",
		"model": "GATEAUX FROIDS A PARTAGER",
		"description": "",
		"status": "Active",
		
	},
	
	{
		"id":8,
		"img": "assets/img/products/product8.jpg",
		"model": "Fruits",
		
		"description": "",
		"status": "Active",
		
	},
	{
		"id":9,
		"img": "assets/img/products/product9.jpg",
		"model": "PISTACHE",	
		"description": "",
		"status": "Active",
		
	},
	{
		"id":10,
		"img": "assets/img/products/product10.jpg",
		"model": "COFFRET VARIÉ",		
		"description": "",
		"status": "Active",
		
	}
]